/**
 * This is extracted so that Jest can mock this module without
 * overwriting other module exports.
 */
export const initialState = [];
